// Feature flags baked in at build time (CRA only exposes REACT_APP_* vars).
//
// RESULTS: the /results, /t/<slug>/results and /m/<id> pages plus the member
// attribution banner. They are fed by Umami on the destination site, so for
// tracks whose posts point at Luma (most of them) they read zero. Hidden by
// default since 2026-09-15; set REACT_APP_SHOW_RESULTS=true to bring them back.
export const RESULTS_ENABLED = process.env.REACT_APP_SHOW_RESULTS === "true";
